<nav #header class="fixed-top headerStyle"
    style="background-color: #0c4733 !important;filter: drop-shadow(1px 1px 1px #6666664d);"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}">
    <div class="container green containerHeader" style="overflow: hidden;margin-bottom: -10px;">
        <div class="mobile" style="flex-grow: 1;">
            <div style="display: flex;justify-content: space-between;">
                <div class="logo-desktop">
                    <a href="https://papayatours.de/" target="_blank">
                        <img class="logo" src="../assets/images/logos-header/pt.svg" />
                    </a>
                </div>
                <div class="menuButton">
                    <a (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
                </div>

            </div>
            <div #header1 [ngClass]="showMenu ? 'showMenu':''" class="mobileMenu">
                <ul class="navbar-nav" [ngClass]="showMenu ? 'menu-backcolor':''" style="padding: 10px; width: 100%;">
                    <li class="nav-item menuItem"><a href="https://papayatours.de/"
                            target="_blank">Reiseziele</a>
                    </li>
                    <li class="nav-item menuItem"><a href="https://papayatours.de/"
                            target="_blank">Gruppenreisen</a></li>
                    <li class="nav-item menuItem"><a href="https://papayatours.de/"
                            target="_blank">Individualreisen</a></li>
                    <li class="nav-item menuItem"><a href="https://papayatours.de/ueber-uns/"
                            target="_blank">Über Papaya</a></li>
                    <li class="nav-item menuItem"><a href="https://papayatours.de/kontakt/"
                            target="_blank">Kontakt</a>
                            <ul class="kontakt-list">
                                <li><span><b>Zentrale</b></span><br/><span><a href="tel:02213555770">02 21/35 55 77-0</a></span><br/><span>(Wochentags 09:00 – 18:00 Uhr)</span></li>
                                <li><span><b>Mittelamerika Individualreisen</b></span><br/><span><a href="tel:022135557739">02 21/35 55 77-39</a></span></li>
                                <li><span><b>Südamerika Individualreisen</b></span><br/><span><a href="tel:022135557738">02 21/35 55 77-38</a></span></li>
                                <li><span><b>Mittel- und Südamerika Gruppenreisen</b></span><br/><span><a href="tel:022135557745">02 21/35 55 77-45</a></span><br/><span>(Wochentags 09:00 – 18:00 Uhr)</span></li>
                                <li><span><b>Asien Individualreisen</b></span><br/><span><a href="tel:022135557755">02 21/35 55 77-55</a></span></li>
                                <li><span><b>Asien Gruppenreisen</b></span><br/><span><a href="tel:022135557756">02 21/35 55 77-56</a></span></li>
                            </ul>
                    </li>
                    <li class="nav-item menuItem">
                        <ul class="kontakt-list">
                            <li><span><b>Soziale Netzwerke</b></span><br/>
                                <span style="display: flex; justify-content: space-between;">
                                    <span><a href="https://facebook.com/papayatours.de"><i class="fa fa-facebook" style="padding-right: 5px;"></i>Facebook</a></span>
                                    <span><a href="https://instagram.com/papayatours.de"><i class="fa fa-instagram" style="padding-right: 5px;"></i>Instagram</a></span>
                                    <span><a href="https://www.youtube.com/channel/UCFfU1CVwEYA-3mszpCzkWXQ"><i class="fa fa-youtube-play" style="padding-right: 5px;"></i>Youtube</a></span>
                                </span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                            <app-heart-header></app-heart-header>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <table style="width: 100%; border: none;" class="desktop">
            <tr>
                <td rowspan="2" style="width: 18%;text-align: center;vertical-align: middle;">
                    <a href="https://papayatours.de/" target="_blank" class="logo-desktop">
                        <img class="logo" src="../assets/images/logos-header/pt.svg" />
                    </a>
                </td>
            </tr>
            <tr>
                <td>
                    <div #header1 class="containerHeader container" [ngClass]="showMenu ? 'showMenu':''">
                        <ul class="navbar-nav" [ngClass]="showMenu ? 'menu-backcolor':''" style="padding: 10px;">
                            <li class="nav-item menuItem"><a href="https://papayatours.de/"
                                    target="_blank">Reiseziele</a>
                            </li>
                            <li class="nav-item menuItem"><a
                                    href="https://papayatours.de/" target="_blank"
                                    onclick="">Gruppenreisen</a></li>
                            <li class="nav-item menuItem"><a href="https://papayatours.de/"
                                    target="_blank">Individualreisen</a></li>
                            <li class="nav-item menuItem"><a href="https://papayatours.de/ueber-uns/"
                                    target="_blank">Über Papaya Tours</a></li>
                            <li class="nav-item menuItem"><a href="https://papayatours.de/kontakt/"
                                    target="_blank">Kontakt</a>
                            </li>
                        </ul>
                        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                            <app-heart-header></app-heart-header>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</nav>